/**
 * Created by Andrey Popov on 10/8/25.
 */

const PathInfoViews = function () {
    this.infoViews = [];
};

PathInfoViews.prototype.updateInfoViews = function (activeUnit, pathUnits, silent) {
    this.infoViews = this.infoViews.filter((infoView) => {
        const unit = infoView.unit;
        if (!pathUnits.find((p) => p === unit)) {
            infoView.stopAllActions();
            infoView.removeFromParent();
            return false;
        }

        this.activateInfoViewIfNeeded(infoView, activeUnit, silent);
        return true;
    });

    for (const pathUnit of pathUnits) {
        const map = Map2d.currentMap;
        const isFogUnit = map.isOccupiedByFog(pathUnit.x, pathUnit.y);
        const units = isFogUnit ? map.fogs.getFakeUnits(pathUnit.x, pathUnit.y) : [pathUnit];

        units.forEach((unit) => {
            const multiple = unit instanceof Unit && unit.findComponent(Multiple);
            if (multiple) {
                if (!multiple.isUnitVisible()) {
                    return;
                }
            }

            if (!this.infoViews.find((iw) => iw.unit === unit)) {
                const simpleInfoView = SimpleInfoView.CreateForUnit(unit);
                if (simpleInfoView) {
                    this.infoViews.push(simpleInfoView);
                    this.activateInfoViewIfNeeded(simpleInfoView, activeUnit, silent);
                } else if (unit instanceof Unit) {
                    const mineable = unit.findComponent(Mineable);
                    if ((mineable && !mineable.isFree()) || !mineable) {
                        InfoView.DisplayInfo(unit);
                    }
                }
            }
        });

        if (isFogUnit) {
            break;
        }
    }
};

PathInfoViews.prototype.activateInfoViewIfNeeded = function (infoView, activeUnit, silent) {
    if (!activeUnit || infoView.unit !== activeUnit || infoView.action) {
        return;
    }

    infoView.setActive(() => {
        const result = activeUnit.findComponent(Mineable).startMine();
        if (result) {
            Map2dLocation.currentLocation.setTimeout(() => {
                infoView.removeFromParent();
                this.infoViews = this.infoViews.filter((iv) => iv !== infoView);
            }, 500);
        }
        return result;
    });

    if (!silent && infoView.unit !== this.lastScrolledUnit) {
        this.lastScrolledUnit = infoView.unit;
        const pathIndicator = Map2d.currentMap.pathIndicator;
        if (pathIndicator) {
            Map2d.currentMap.focusOnUnit(pathIndicator.getOffsetScrollTarget(infoView.unit), {
                skipFocusReport: true,
                allowScrollWithFocus: true
            });
        } else {
            cleverapps.Scenes.GetSceneComponent(Map2dLocationSceneComponent).makeNodeVisible(infoView);
        }
    }
};

PathInfoViews.prototype.removeInfoViewForUnit = function (unit) {
    this.infoViews = this.infoViews.filter((infoView) => {
        if (unit === infoView.unit) {
            infoView.stopAllActions();
            infoView.removeFromParent();
            return false;
        }

        return true;
    });
};

PathInfoViews.prototype.onLivesAmountChanged = function () {
    this.infoViews.forEach((infoView) => {
        infoView.createContent();
    });
};

PathInfoViews.prototype.getUnitInfoView = function (unit, activeOnly) {
    const infoView = this.infoViews.find((iw) => iw.unit === unit);
    if (infoView && activeOnly && !infoView.action) {
        return undefined;
    }
    return infoView;
};

PathInfoViews.prototype.hide = function (silent) {
    this.infoViews.forEach((infoView) => {
        infoView.stopAllActions();
        if (silent) {
            infoView.removeFromParent();
        } else {
            infoView.runAction(new cc.Sequence(
                new cc.ScaleTo(0.05, 0.5, 0.5).easing(cc.easeIn(1)),
                new cc.RemoveSelf()
            ));
        }
    });
    this.infoViews = [];
};